<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
    fill="currentColor"
  />
  <path
    d="M5 7.00004C5.5 7.00001 9 6.99997 11 7.00004C11.5523 7.00005 12 7.44775 12 8.00004C12 8.55232 11.5523 9.00005 11 9.00003C9.5 9 5.5 9.00002 5 9.00003C4.44772 9.00005 4 8.55232 4 8.00004C4 7.44775 4.44772 7.00006 5 7.00004Z"
    fill="currentColor"
  />
  <path
    d="M7.00004 11C7.00001 10.5 6.99997 7 7.00004 5C7.00005 4.44772 7.44775 4 8.00004 4C8.55232 4 9.00005 4.44772 9.00003 5C9 6.5 9.00002 10.5 9.00003 11C9.00005 11.5523 8.55232 12 8.00004 12C7.44775 12 7.00006 11.5523 7.00004 11Z"
    fill="currentColor"
  />
</svg>
